import { Dispatch } from 'redux';
import { SubscriptionTypes } from './Types';
import { ApiEndpoints, ActionHandler } from 'Utils';

export const createSubscription =
	(descriptor: string, opaqueData: string, plan: string, amount: string, childId: string) =>
	(dispatch: Dispatch) => {
		// const childId = localStorage.getItem('currentChildId')

		const data = JSON.stringify({ plan, amount, descriptor, childId: childId, opaqueData });

		return ActionHandler(
			{ url: ApiEndpoints.subscribe, method: 'POST', dispatch, data },

			res => {
				const { data } = res.data;

				dispatch({ type: SubscriptionTypes.CREATE_SUBSCRIPTION });
			},
			error => {
				// console.log()
				const { data } = error;
				// eslint-disable-next-line no-console
				console.log('my errror here', data);

				dispatch({ type: SubscriptionTypes.Errors, payload: { errors: data } });
			},
		);
	};

export const upgradeSubscription =
	(descriptor: string, opaqueData: string, plan: string, amount: string, childId: string) =>
	(dispatch: Dispatch) => {
		const data = JSON.stringify({ plan, amount, descriptor, childId: childId, opaqueData });

		const newUrl = `${ApiEndpoints.upgrade}/${childId}`;
		return ActionHandler(
			{ url: newUrl, method: 'PUT', dispatch, data },

			res => {
				const { data } = res.data;

				dispatch({ type: SubscriptionTypes.CREATE_SUBSCRIPTION });
			},
			error => {
				const { data } = error;

				dispatch({ type: SubscriptionTypes.Errors, payload: { errors: data } });
			},
		);
	};

export const cancelSubscription = (id: number) => (dispatch: Dispatch) => {
	const newUrl = `${ApiEndpoints.cancelSubscription}/${id}`;
	return ActionHandler(
		{ url: newUrl, method: 'PUT', dispatch },

		res => {
			const { data } = res.data;

			dispatch({ type: SubscriptionTypes.CANCEL_SUBSCRIPTION, payload: data });
		},
		error => {
			const { data } = error.response;
			dispatch({ type: SubscriptionTypes.Errors, payload: { errors: data } });
			// dispatch({ type: ResourceTypes.Errors, payload: { errors: data } });
		},
	);
};
